import ModalAlertComponent from './ModalAlertComponent';
import ModalAlert from './ModalAlert';

export default ModalAlertComponent;
export { ModalAlert };
